import TrendingList from "./component";
import Fetch from "./fetch";
import { LAYOUT_VERTICAL } from "./constants";
import ErrorBoundary from "../ErrorBoundary/component";
import { Heading } from "../Heading/component";
import { capitalizeFirstLetter } from "../../utils/path/library";
import { DISPLAY_TYPES } from "../ContentList/constants";

const TrendingHeading = ({ sectionLabel }) => (
    <Heading
        text={`Popular Now${sectionLabel || []}`}
        level="h2"
        levelClassName="h3"
    />
);

export const TrendingListSidebarPlainComponent = (props) => {
    const { hideSectionLabel, trendingHeaderOverride, section } = props;
    const showsSectionLabel =
        hideSectionLabel === true
            ? null
            : ` in ${capitalizeFirstLetter(section)}`;
    return (
        <ErrorBoundary>
            <TrendingHeading
                sectionLabel={trendingHeaderOverride || showsSectionLabel}
            />
            <TrendingList
                {...props}
                layout={LAYOUT_VERTICAL}
                displayType={DISPLAY_TYPES.TYPE_LIST_ORDERED}
            />
        </ErrorBoundary>
    );
};

const TrendingNewsLandingPlainComponent = (props) => {
    return (
        <ErrorBoundary>
            <TrendingHeading />
            <TrendingList
                {...props}
                layout={LAYOUT_VERTICAL}
                displayType={DISPLAY_TYPES.TYPE_LIST_ORDERED}
                listAriaLabel={"Popular Now"}
            />
        </ErrorBoundary>
    );
};

const TrendingListSidebarFetch = Fetch(
    TrendingListSidebarPlainComponent,
    "news"
);

export const TrendingListSidebar = (props) => {
    const trending = <TrendingListSidebarFetch {...props} />;

    return (
        <div
            className="trendingList-sidebar"
            data-testid="trendingList-sidebar"
        >
            {trending}
        </div>
    );
};

const TrendingListNewsLandingFetch = Fetch(
    TrendingNewsLandingPlainComponent,
    "news"
);

export const TrendingListNewsLanding = (props) => {
    const trending = <TrendingListNewsLandingFetch {...props} />;

    return (
        <div
            className="trendingList-sidebar trendingList-news"
            data-testid="trendingList-news"
        >
            {trending}
        </div>
    );
};
